import React, { useCallback } from 'react';
import dynamic from 'next/dynamic';
import { useIdleCallback } from '@shopify/react-idle';
import { fetchShops, getShopsData } from '@fh-components/fh-js-api-core/store/slices/shopsSlice';
import { useSelector } from 'react-redux';
import { Loader } from '@/components';
import { handleError } from '@/lib/handleError';
import { getCorrectName } from '@/utils';
import { Container, BreadCrumbs, MetaData } from '@/containers';
import ecommerce from '@/seo/Ecommerce';

import styles from './Shops.module.scss';

const ShopsMap = dynamic(() => import('../../components/shopsMap/ShopsMap'), {
	loading: () => <Loader />,
});

const ShopsViews = dynamic(() => import('../../components/shopsView'), {
	loading: () => <Loader />,
});

export default function NextShopsPage(props) {
	const { data } = useSelector(getShopsData);
	const shops = data?.shops ?? [];
	const breadcrumbs = [{ name: 'Магазины', slug: 'shops' }];

	const setPageType = useCallback(() => {
		ecommerce.setPageType(ecommerce.PAGE_TYPES.CONTACTS);
	}, []);

	useIdleCallback(setPageType);

	return (
		<>
			<MetaData
				title='Адреса магазинов FH.BY на карте'
				description='Справочная информация о магазинах FH.BY - адреса магазинов на карте, фото, телефоны и время работы магазинов, представленных в каталоге FH.BY'
				seo={props?.seo}
			/>

			<Container>
				<div className={styles.tabsContainer}>
					<div className={styles.leftSide}>
						<div className={styles.breadcrumbs}>
							<BreadCrumbs breadcrumbs={breadcrumbs} />
						</div>

						<h1 className={styles.title}>
							{props?.seo && props?.seo.h1 ? getCorrectName(props.seo.h1) : 'Магазины'}
						</h1>
					</div>

					<ShopsViews isStatic />
				</div>
			</Container>

			<ShopsMap {...props} shops={shops} />
		</>
	);
}

NextShopsPage.getInitialProps = async ({ reduxStore, query }) => {
	const { latitude = '' } = query;
	await reduxStore.dispatch(fetchShops());

	const pageData = getShopsData(reduxStore.getState());
	handleError(pageData.error);

	return { latitude };
};
